<template>
  <b-overlay
    :show="isLoading"
    rounded="sm"
  >
    <v-select
      v-model="selectedPeriodo"
      :options="periodosList"
      :placeholder="isLoading ? 'Cargando ...' : 'Seleccione'"
      label="clave"
      :clearable="true"
      class="w-100"
    />
  </b-overlay>
</template>

<script>
import { BOverlay } from 'bootstrap-vue'
import { ref, watch } from '@vue/composition-api'
import vSelect from 'vue-select'
import { fillPeriodos } from './useWebService'

export default {
  components: {
    vSelect,
    BOverlay,
  },
  props: {
    periodoId: {
      type: Number,
      default: null,
    },
    planId: {
      type: Number,
      default: null,
    },
    isDisabled: Boolean,
    autoSelectFirst: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const periodos = ref([])
    const selectedPeriodo = ref(null)
    const isLoading = ref(false)

    // Token para evitar race conditions
    let requestToken = 0

    const getDefaultPeriodo = () => {
      if (!periodos.value.length) return null
      return periodos.value.reduce((max, item) => (item.id > max.id ? item : max))
    }

    const syncFromParent = () => {
      if (!periodos.value.length) {
        selectedPeriodo.value = null
        return
      }

      // Si el padre manda ID
      if (props.periodoId != null) {
        const found = periodos.value.find(p => p.id === props.periodoId)
        selectedPeriodo.value = found || null
        return
      }

      // Auto select
      if (props.autoSelectFirst) {
        selectedPeriodo.value = getDefaultPeriodo()
      }
    }

    const fetchPeriodos = async () => {
      if (props.planId == null) {
        periodos.value = []
        selectedPeriodo.value = null
        return
      }

      requestToken += 1
      const currentToken = requestToken

      isLoading.value = true

      try {
        const data = await fillPeriodos(props.planId)

        // Si ya hubo otra request después, ignoramos esta
        if (currentToken !== requestToken) return

        periodos.value = Array.isArray(data) ? data : []
      } catch (error) {
        if (currentToken !== requestToken) return

        if (error?.response?.status === 204) {
          periodos.value = []
        } else {
          // console.error('Error loading periodos:', error)
          periodos.value = []
        }
      } finally {
        if (currentToken === requestToken) {
          isLoading.value = false
        }
      }

      syncFromParent()
    }

    watch(selectedPeriodo, p => {
      if (isLoading.value) return

      const id = p?.id ?? null
      if (id === props.periodoId) return

      emit('update:periodoId', id)
      emit('change', id)
    })

    watch(
      () => props.planId,
      async (newVal, oldVal) => {
        if (newVal === oldVal) return

        selectedPeriodo.value = null
        periodos.value = []

        await fetchPeriodos()
      },
      { immediate: true },
    )

    watch(
      () => props.periodoId,
      () => {
        if (!isLoading.value) {
          syncFromParent()
        }
      },
    )

    return {
      periodosList: periodos,
      selectedPeriodo,
      isLoading,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
